import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../constants/queryKeys";
import useActiveUserQuery from "../userHooks/useActiveUserQuery";
import { fetchPendingProjectCounts } from "../../api/dashboard/fetchPendingProjectCounts";

export const usePendingProjectCountsQuery = () => {
  const { isSuccess } = useActiveUserQuery();
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_PENDING_PROJECTS_COUNT],
    queryFn: async () => {
      return fetchPendingProjectCounts();
    },
    enabled: isSuccess,
  });
};
